<template>
  <v-scroll-x-transition>
    <v-card
      class="searchResult ma-1"
      outlined
      elevation="3"
      @click="panToResult"
    >
      <v-card-title>
        <v-list-item>
          <v-list-item-avatar
            tile
          >
            <v-img
              v-if="$icons.getIconById(poi.category) !== undefined &&
                !$icons.getIconById(poi.category).useAsMdi"
              contain
              :src="$icons.getIconById(poi.category).icon"
            />
            <v-icon
              v-else-if="$icons.getIconById(poi.category) !== undefined &&
                $icons.getIconById(poi.category).useAsMdi"
              color="#0D0D0D"
            >
              {{ $icons.getIconById(poi.category).icon }} mdi-36px
            </v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="text text-wrap">
              {{ poi.label }}
            </v-list-item-title>
            <v-list-item-subtitle class="text text-wrap">
              {{ poi.sublabel }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-card-title>
    </v-card>
  </v-scroll-x-transition>
</template>

<script>
import PointOfInterest from '../../model/PointOfInterest';
import { EventBus } from '../../event-bus';

export default {
  name: 'SearchResult',
  components: {},
  props: {
    poi: {
      type: PointOfInterest,
      default: null,
    },
    searchAtPoi: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      latitude: 0,
      longitude: 0,
    };
  },
  created() {
    const lonLat = this.poi.centerCoordinate.split(',');
    this.longitude = parseFloat(lonLat[1]);
    this.latitude = parseFloat(lonLat[0]);
  },
  methods: {
    panToResult() {
      this.$store.commit('setDetailViewOrigin', 'search');
      this.$store.commit('showDetailView', this.poi);
      // pans to the specific search result if the user clicks the card
      this.$store.commit('closeSearchMenu');
      const latlon = [this.longitude, this.latitude];
      if (this.searchAtPoi === undefined) {
        EventBus.$emit('draw-feature', latlon, true, true, this.poi);
      } else {
        EventBus.$emit('draw-feature', latlon, true, true, this.poi, false);
      }
    },
  },
};

</script>

<style scoped>

  .searchResult {
    border-radius: 7px;
    margin: 1%;
    word-wrap: break-word;
    /* word-break: break-all */
  }

  .text {
    word-wrap: break-word;
    word-break: break-all;
-webkit-hyphens: auto;
   -moz-hyphens: auto;
        hyphens: auto;
  }
</style>
